export const TOAST_MESSAGES = {
  ADV_NOTES_FETCH_FAILED: "Failed to fetch Advance notes",
  ADV_NOTES_FETCH_ERROR: "Error fetching Advance notes!",
  ADV_NOTE_FETCH_FAILED: "Failed to fetch Advance Note",
  ADV_NOTE_FETCH_ERROR: "Error fetching Advance Note!",
  ADV_NOTE_CREATE_SUCCESS: "Advance Note created successfully",
  ADV_NOTE_CREATE_FAILED: "Failed to create Advance note",
  ADV_NOTE_CREATE_ERROR: "Error creating Advance note!",
  ADV_NOTE_UPDATE_SUCCESS: "Advance Note updated successfully",
  ADV_NOTE_UPDATE_FAILED: "Failed to update Advance note",
  ADV_NOTE_UPDATE_ERROR: "Error updating Advance note!",
  ADV_NOTE_DELETE_SUCCESS: "Advance Note deleted successfully",
  ADV_NOTE_DELETE_FAILED: "Failed to delete Advance note!",
  ADV_NOTE_DELETE_ERROR: "Error deleting Advance note!",
  ADV_NOTE_DELETE_ALERT: "Are you sure you want to delete this Advance note?",
  FAIL_USERS_FETCH: "Failed to fetch users",
  ERROR_USERS_FETCH: "Error fetching users",
  FAIL_SITES_FETCH: "Failed to fetch users",
  ERROR_SITES_FETCH: "Error fetching users",
  FAIL_CATEGORIES_FETCH: "Failed to fetch users",
  ERROR_CATEGORIES_FETCH: "Error fetching users",
  ERROR_FETCHING_PROJECTS: "Error fetching projects"
};

export const MISC = {
  NOT_AVAILABLE: "N/A",
  NO_ADVANCE_NOTES_FOUND: "No advance notes found",
};

export const ADVANCE_NOTE_LABELS = {
  project_name: "Project",
  site_name: "Site",
  amount: "Amount",
  user_name: "User",
  category_name: "Category",
  date: "Date",
  note: "Note",
  status: "Status",
  actions: "Actions",
};

export const ADVANCE_NOTE_COLUMNS = [
  "project_name",
  "site_name",
  "user_name",
  "category_name",
  "date",
  "amount",
  "status",
  "actions",
];

export const ADVANCE_NOTE_STATUS = {
  DRAFT: "DRAFT",
  PENDING_FOR_APPROVAL: "PENDING_FOR_APPROVAL",
  APPROVED: "APPROVED",
};

export const ADVANCE_NOTE_STATUS_LABELS = {
  DRAFT: "Draft",
  PENDING_FOR_APPROVAL: "Pending for Approval",
  APPROVED: "Approved"
};

export const ADVANCE_NOTE_STATUS_OPTIONS = [
  { id: "", name: "All Statuses" },
  { id: "DRAFT", name: "Draft" },
  { id: "PENDING_FOR_APPROVAL", name: "Pending for Approval" },
  { id: "APPROVED", name: "Approved"}
];

export const getAdvanceNoteStatusColor = (status) => {
  switch (status) {
    case "DRAFT":
      return "bg-gray-200 text-gray-700 transition-colors";
    case "PENDING_FOR_APPROVAL":
      return "bg-blue-50 text-blue-500 transition-colors";
    case "APPROVED":
      return "bg-green-100 text-green-700 transition-colors";
    default:
      return "bg-white text-black transition-colors";
  }
};

export const ADVANCE_NOTE_MODES = {
  CREATE: "Create",
  EDIT: "Edit",
  VIEW: "View",
};

export const ADVANCE_NOTE_TOOLTIP = {
  VIEW_TEXT: "View Advance Note",
  EDIT_TEXT: "Edit Advance Note",
  DELETE_TEXT: "Delete Advance Note",
  CAN_NOT_DELETE: "Can not delete in this state",
  CAN_NOT_EDIT: "Can not edit in this state"
}